import { api } from '@/services'

export const searchInvoices = (params) => {
  return api.get('web/invoice/search', { params })
}

export const generateInvoiceZip = (params) => {
  return api.get('/web/invoice/downloadZip', {
    params,
    responseType: 'blob'
  })
}